module.exports = __webpack_public_path__ + "img/1527483300.00c028e1.jpg";